import React, { useState, useEffect,useCallback  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useProducer } from "../context/ProducerContext";
import { addCartByCustomer, getCartProducts, updateCartSize } from "../api/cartApi";
import { QRCodeCanvas } from "qrcode.react";
import { FaShoppingCart } from "react-icons/fa";

export default function PaymentQRCode() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { producer, customer } = useProducer(); // assuming customer info comes from context
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);


  const loadCartFromAPI = useCallback(async () => {
    if (!customer?.id || !producer?.id) return;

    try {
      const payload = { customerId: customer.id, producerId: producer.id };
      const res = await getCartProducts(payload);
      setCart(res.data || []);
    } catch (error) {
      console.error("Fetch Cart Error:", error);
    }
  });

  useEffect(() => {
    loadCartFromAPI();
  }, [customer, producer]);

  if (!state) return <p>No payment data provided</p>;

  const { totalAmount } = state;
  const qrData = `Amount to Pay: ₹${totalAmount}`;

  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <nav className="bg-white shadow p-4 flex justify-between items-center w-full max-w-3xl">
        <div>
          <h1 className="text-xl font-semibold">{producer?.name}</h1>
          <p className="text-sm text-gray-500">{producer?.city}</p>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setShowCart(true)}
            className="relative bg-gray-100 p-2 rounded-full hover:bg-gray-200"
          >
            <FaShoppingCart size={24} />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                {cartCount}
              </span>
            )}
          </button>

          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded"
          >
            Logout
          </button>
        </div>
      </nav>

      <h1 className="text-2xl font-bold my-4">Scan to Pay</h1>

      <div className="bg-white p-6 shadow-lg rounded-xl">
        <QRCodeCanvas value={qrData} size={256} />
      </div>

      <p className="mt-4 text-xl font-semibold">
        Amount: ₹{totalAmount}
      </p>

      <button
        className="mt-6 bg-gray-800 text-white px-6 py-2 rounded"
        onClick={() => navigate(-1)}
      >
        Back
      </button>

      {/* Optional Cart Modal */}
      {showCart && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-96 shadow-lg max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-4">Your Cart</h2>
            {cart.length === 0 ? (
              <p className="text-gray-600">Cart is empty</p>
            ) : (
              <ul>
                {cart.map((item) => (
                  <li key={item.id} className="flex justify-between mb-2">
                    <span>{item.name}</span>
                    <span>Qty: {item.quantity}</span>
                  </li>
                ))}
              </ul>
            )}
            <button
              onClick={() => setShowCart(false)}
              className="mt-4 bg-gray-800 text-white px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
